import { api } from 'utils'
import { useEffect } from 'react'
import { PAYPAL_CREATE_ORDER } from 'utils/endpoint'
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
  usePayPalScriptReducer,
} from '@paypal/react-paypal-js'

const PaypalButton = ({ confirmOrder, isValid, fundingSource }) => {
  useEffect(() => {}, [isValid])

  return (
    <PayPalScriptProvider
      options={{
        'debug': process.env.NODE_ENV === 'development' ? true : false,
        'currency': 'EUR',
        'client-id': process.env.PAYPAL_CLIENT_ID,
        //'vault': 'true',
        'data-namespace': 'paypal_button',
      }}
    >
      <PayPalButtons
        fundingSource={fundingSource}
        disabled={isValid}
        style={{ layout: 'vertical', label: 'paypal' }}
        onApprove={(data, actions) => {
          return actions.order
            .capture()
            .then(() => {
              confirmOrder()
            })
            .catch((err) => {
              console.log(err)
            })
        }}
        createOrder={async (data, actions) => {
          const res = await api.get(`${PAYPAL_CREATE_ORDER}`)
          return res.data.id
        }}
      />
    </PayPalScriptProvider>
  )
}

export default PaypalButton
